const C = {
  name: "ShopperBag",
  dimensions: { width: 28, height: 41 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M2 37V10H6V14C6 14.55 6.45 15 7 15C7.55 15 8 14.55 8 14V10H20V14C20 14.55 20.45 15 21 15C21.55 15 22 14.55 22 14V10H25C25.55 10 26 10.45 26 11V38H3C2.45 38 2 37.55 2 37ZM14 2C17.31 2 20 4.69 20 8H8C8 4.69 10.69 2 14 2ZM26 8H22C22 3.59 18.41 0 14 0C9.59 0 6 3.59 6 8H2C0.9 8 0 8.9 0 10V38C0 39.1 0.9 40 2 40H26C27.1 40 28 39.1 28 38V10C28 8.9 27.1 8 26 8Z"/>
    </g>
  `
};
export {
  C as ShopperBag
};
